import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Task } from './task.model';
import taskService from './task.service';

// namespace
export const TASK_STORE_NAMESPACE = 'taskStore';

// state
interface TaskState {
  tasks: Task[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: TaskState = {
  tasks: [],
  status: 'init',
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<TaskState> = {
  [mutationConstant.FETCH]: (state: TaskState, tasks: Task[]) => {
    state.tasks = tasks;
  },
  [mutationConstant.PENDING]: (state: TaskState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: TaskState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: TaskState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<TaskState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<TaskState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      taskService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_TYPE: 'byType',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<TaskState, RootState> = {
  [getterConstant.ALL]: (state: TaskState) => state.tasks,
  [getterConstant.BY_TYPE]: (state: TaskState) => (typeId: number, provinceId: number, startDate: Date, endDate: Date) => state.tasks.filter(m =>
    m.provinceTaskType.id === typeId &&
    m.provinceTaskDate >= startDate && m.provinceTaskDate <= endDate &&
    m.province.id === provinceId),
  [getterConstant.BY_ID]: (state: TaskState) => (id: number) => state.tasks.find(m => m.id === id),
  [getterConstant.STATUS]: (state: TaskState) => state.status,
};

// module
const module: Module<TaskState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const TaskGetter = {
  ALL: `${TASK_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_TYPE: `${TASK_STORE_NAMESPACE}/${getterConstant.BY_TYPE}`,
  BY_ID: `${TASK_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${TASK_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const TaskAction = {
  FETCH: `${TASK_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
